import { useAtomValue, useSetAtom } from 'jotai';

import { closePanelAtom, panelsAtom } from '@/stores/panels';
import { ResponsivePanelWrapper } from '@/components/ui/ResponsivePanelWrapper';
import { QuickAddTaskContent, NewTaskData } from './QuickAddTaskContent';

interface QuickAddTaskPanelProps {
  onSave: (task: NewTaskData) => void;
}

export function QuickAddTaskPanel({ onSave }: QuickAddTaskPanelProps) {
  const panels = useAtomValue(panelsAtom);
  const closePanel = useSetAtom(closePanelAtom);

  return (
    <ResponsivePanelWrapper panelId="quickAddTask" title="New Task">
      <QuickAddTaskContent
        isOpen={panels.quickAddTask.isOpen}
        onClose={() => closePanel('quickAddTask')}
        onSave={onSave}
      />
    </ResponsivePanelWrapper>
  );
}

export default QuickAddTaskPanel;
